function isAffirmativeKeypress(f) {
  return e => (e.key === 'Enter' || e.key === ' ') && f(e);
}
function usePress(args) {
  const {
    onPress
  } = args;
  return {
    pressProps: {
      onClick: e => onPress?.({
        type: 'click',
        event: e
      }),
      onKeyDown: e => {
        if (e.key === 'Enter' || e.key === ' ') {
          onPress?.({
            type: 'keyDown',
            event: e
          });
        }
      },
      onTouchEnd: e => {
        onPress?.({
          type: 'touchEnd',
          event: e
        });
      }
    }
  };
}
function useFocus(args) {
  const {
    onFocus,
    onBlur
  } = args;
  return {
    focusProps: {
      onFocus: e => onFocus?.(e),
      onBlur: e => onBlur?.(e)
    }
  };
}

export { isAffirmativeKeypress, useFocus, usePress };
